import React from "react";
import classNames from "classnames";

const ValidatedInput = ({
  label,
  type = "text",
  value,
  onChange,
  onBlur,
  placeholder,
  maxLength,
  error,
  disabled = false,
  required = false,
}) => {
  const inputClasses = classNames("newyear-input__field", {
    "newyear-input__field--error": error,
    "newyear-input__field--disabled": disabled,
  });

  return (
    <div className="newyear-input">
      {label && (
        <label className="newyear-input__label">
          {label}
          {required && <span className="newyear-input__required">*</span>}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={inputClasses}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        required={required}
      />
      {error && <span className="newyear-input__error">{error}</span>}
    </div>
  );
};

export default ValidatedInput;
